(function () {
  'use strict';

  var MIN_QUERY_LENGTH = 3;
  var DEBOUNCE_MS = 220;

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function buildResultsUrl(query) {
    return '/search?type=product&q=' + encodeURIComponent(query);
  }

  function normalizeImage(src) {
    if (!src) return '';
    return src.indexOf('//') === 0 ? window.location.protocol + src : src;
  }

  function productCard(product) {
    var image = normalizeImage(product.image);
    var title = escapeHtml(product.title);
    var vendor = escapeHtml(product.vendor);
    var sku = escapeHtml(product.sku);
    var stockClass = product.available ? 'is-available' : 'is-unavailable';
    var stockText = product.available ? 'In stock' : 'Check availability';
    var price = product.on_sale
      ? '<div class="product-price price--on-sale"><span class="price-item price-item--regular" data-regular-price>' + escapeHtml(product.compare_at_price) + '</span><span class="price-item price-item--sale">' + escapeHtml(product.price) + '</span></div>'
      : '<div class="product-price"><span class="price-item price-item--regular" data-regular-price>' + escapeHtml(product.price) + '</span></div>';

    return [
      '<div class="halo-item">',
        '<div class="product-card">',
          '<div class="product-image">',
            '<a href="' + escapeHtml(product.url) + '" class="product-link">',
              image ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.image_alt || product.title) + '">' : '',
            '</a>',
          '</div>',
          '<div class="product-content">',
            vendor ? '<div class="product-vendor">' + vendor + '</div>' : '',
            '<div class="product-title"><a href="' + escapeHtml(product.url) + '">' + title + '</a></div>',
            '<div class="product-search-meta">',
              sku ? '<span>SKU: ' + sku + '</span>' : '',
              '<span class="' + stockClass + '">' + stockText + '</span>',
            '</div>',
            price,
          '</div>',
        '</div>',
      '</div>'
    ].join('');
  }

  function loadingMarkup() {
    return '<div class="header-search__results header-block"><p class="header-search__no-results text-results">Searching...</p></div>';
  }

  function renderResults(data, query) {
    var results = Array.isArray(data.results) ? data.results : [];

    if (!results.length) {
      return [
        '<div class="header-search__results header-block">',
          '<p class="header-search__no-results text-results">No matching parts found.</p>',
        '</div>'
      ].join('');
    }

    return [
      '<div class="header-search__results header-block">',
        '<h3 class="title">Matching Parts</h3>',
        '<div class="search__products"><div class="halo-row column-3">',
          results.map(productCard).join(''),
        '</div></div>',
        '<div class="text-center">',
          '<a href="' + buildResultsUrl(query) + '" class="text-results header-search__see-more" data-results-count="' + Number(data.results_count || results.length) + '">',
            '<span class="text">View all matching parts</span> <span>(' + Number(data.results_count || results.length) + ')</span>',
          '</a>',
        '</div>',
      '</div>'
    ].join('');
  }

  function bindSearch(root) {
    if (!root || root.dataset.arSearchBound === 'true') return;

    var input = root.querySelector('.header-search__input');
    var wrapper = root.querySelector('.quickSearchResultsWrap');
    var results = root.querySelector('.header-search__results-wrapper');
    var popular = root.querySelector('.header-search__product');
    var trending = root.querySelector('.header-search__trending');
    var timer;
    var abortController;

    if (!input || !wrapper || !results) return;

    root.dataset.arSearchBound = 'true';

    function show() {
      wrapper.style.display = 'block';
    }

    function hide() {
      wrapper.style.display = 'none';
    }

    function setDefaultState() {
      results.innerHTML = '';
      if (popular) popular.style.display = '';
      if (trending) trending.style.display = '';
      if ((popular && popular.textContent.trim()) || (trending && trending.textContent.trim())) {
        show();
      } else {
        hide();
      }
    }

    function runSearch() {
      var query = input.value.trim();

      if (abortController) abortController.abort();

      if (query.length < MIN_QUERY_LENGTH) {
        setDefaultState();
        return;
      }

      abortController = new AbortController();
      if (popular) popular.style.display = 'none';
      if (trending) trending.style.display = 'none';
      results.innerHTML = loadingMarkup();
      show();

      fetch('/search?view=json&type=product&q=' + encodeURIComponent(query + '*'), {
        headers: { Accept: 'application/json' },
        signal: abortController.signal
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Search request failed');
          return response.json();
        })
        .then(function (data) {
          results.innerHTML = renderResults(data, query);
          show();
        })
        .catch(function (error) {
          if (error.name === 'AbortError') return;
          results.innerHTML = '<div class="header-search__results header-block"><p class="header-search__no-results text-results">Search is unavailable right now.</p></div>';
          show();
        });
    }

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= MIN_QUERY_LENGTH) {
        runSearch();
      } else {
        setDefaultState();
      }
    });

    input.addEventListener('input', function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(runSearch, DEBOUNCE_MS);
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) hide();
    });
  }

  function init() {
    document.querySelectorAll('[data-ajax-search]').forEach(bindSearch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
